
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { Procedure, ApiGateway, RegistryType } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class RegistryTypeEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    registryType: RegistryType;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getRegistryType()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getRegistryType(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.registryType = data;
                this.onDataChanged.next(this.registryType);
                resolve(this.registryType);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('registryType/' + this.routeParams.id).subscribe((res: RegistryType ) => {
                    this.registryType = res;
                    this.onDataChanged.next(this.registryType);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(registryType): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('registryType/', registryType).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(registryType): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('registryType/', registryType).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(registryType): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('registryType/' + registryType.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): RegistryType {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
